/** Hosts where no-sign-in review routes (/lesson-review) may open: dev and
 *  branch previews (`<branch>.fluent-ge-app.pages.dev`). Never production —
 *  app.fluent.ge, nor the project's own fluent-ge-app.pages.dev name, which
 *  serves the production build. */
export function isReviewHost(hostname: string): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.fluent-ge-app.pages.dev')
  );
}
